module.exports = __webpack_public_path__ + "img/av_penguin.80792892.png";